/**
 * @generated SignedSource<<35e22cae93971d2133b9bca87c1fafa0>>
 * @relayHash 9ecc23fb0a7f9be715f33eb5ea4b5a04
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/556.0.0-2026-04-21T14:51:08.285Z/pdpRespMarketplacePrimaryRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type pdpRespMarketplacePrimaryRootQuery$variables = {
  afterDisplay?: boolean | null;
  afterDisplayOrBtSsr?: boolean | null;
  fetchPdp?: boolean | null;
  fetchUser?: boolean | null;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  forcedCurrency?: Currency | null;
  isEstimateSimilarSoldVariant?: boolean | null;
  isInteractivePdpChat?: boolean | null;
  isMultiSku?: boolean | null;
  isPDPLargerItemsVariant?: boolean | null;
  isPdpSiderailSellerReviewCombinedVariant?: boolean | null;
  isPdpSimilarSoldItemsModuleVariant?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  personalizationId?: string | null;
  priceBookName?: string | null;
  similarItemsCount: number;
  userCountryCode?: string | null;
  userId?: string | null;
  userIds: ReadonlyArray<string | null>;
  userZipCode?: string | null;
};
export type pdpRespMarketplacePrimaryRootQuery$data = {
  readonly viewer: {
    readonly itemRead: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_item" | "PersonalizedCollectionsContext_item" | "findPdpItemReadError_itemRead" | "handlePdpStatuses_item">;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpHeadBuilder_viewer" | "PdpRespMarketplaceLayoutPrimary_viewer">;
  };
};
export type pdpRespMarketplacePrimaryRootQuery = {
  response: pdpRespMarketplacePrimaryRootQuery$data;
  variables: pdpRespMarketplacePrimaryRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplay"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "afterDisplayOrBtSsr"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchPdp"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v5 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forcedCurrency"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isEstimateSimilarSoldVariant"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isInteractivePdpChat"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isMultiSku"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPDPLargerItemsVariant"
},
v11 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPdpSiderailSellerReviewCombinedVariant"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPdpSimilarSoldItemsModuleVariant"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemIds"
},
v16 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v17 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "similarItemsCount"
},
v19 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v20 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userIds"
},
v22 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v23 = {
  "alias": "isPdpUrlTranslationEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "translatedPdpUrls"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabled",
  "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
},
v24 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "microdata",
  "storageKey": null
},
v26 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v27 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v28 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "currency",
      "variableName": "forcedCurrency"
    },
    (v26/*: any*/),
    (v27/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "microdataOffers",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ogTitle",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceAmount",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productPriceCurrency",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageAnnotations",
  "kind": "LinkedField",
  "name": "languageAnnotations",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hrefLang",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webPath",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v40 = [
  (v39/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageVersionType",
      "kind": "LinkedField",
      "name": "type",
      "plural": false,
      "selections": (v40/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPriceUponRequest",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingListed",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingNotListed",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingUnlisted",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isListingMigrated",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNew",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWip",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSold",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInternal",
  "storageKey": null
},
v55 = [
  {
    "kind": "Literal",
    "name": "metricTypes",
    "value": [
      "ITEM_LISTING_VIEWS"
    ]
  },
  {
    "kind": "Literal",
    "name": "timeRange",
    "value": "LAST_6_MONTHS"
  }
],
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v57 = [
  (v56/*: any*/)
],
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateVisibilityType",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrivateListing",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirectType",
  "kind": "LinkedField",
  "name": "redirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageType",
      "storageKey": null
    }
  ],
  "type": "ItemReadError",
  "abstractKey": null
},
v63 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v64 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v65 = [
  (v63/*: any*/),
  (v64/*: any*/)
],
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v68 = [
  (v66/*: any*/),
  (v67/*: any*/)
],
v69 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v70 = [
  (v69/*: any*/)
],
v71 = {
  "alias": "monthsSinceStartDate",
  "args": [
    {
      "kind": "Literal",
      "name": "unit",
      "value": "MONTH"
    }
  ],
  "kind": "ScalarField",
  "name": "timeSinceStartDate",
  "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProfile",
  "kind": "LinkedField",
  "name": "sellerProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "alias": "isRewardsTier2",
  "args": [
    {
      "kind": "Literal",
      "name": "listName",
      "value": "SELLER_REWARDS_2"
    }
  ],
  "kind": "ScalarField",
  "name": "isAnchorListMember",
  "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGoldTier",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPlatinumTier",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerTierDataNotFound",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerTiers",
  "kind": "LinkedField",
  "name": "sellerTiers",
  "plural": false,
  "selections": [
    (v74/*: any*/),
    (v75/*: any*/),
    (v76/*: any*/)
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatedOrderFeedbackType",
      "kind": "LinkedField",
      "name": "aggregatedFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackQuestionType",
          "kind": "LinkedField",
          "name": "overallExperience",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mean",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicNoteTotalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDistinguished",
  "storageKey": null
},
v80 = [
  (v64/*: any*/)
],
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v82 = [
  (v69/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
],
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAcceptOffer",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPurchase",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMakeOffer",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showRequestPrice",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showFollowCategory",
  "storageKey": null
},
v88 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      (v85/*: any*/)
    ],
    "storageKey": null
  }
],
v89 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v90 = {
  "alias": null,
  "args": (v89/*: any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v92 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v93 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v94 = [
  (v69/*: any*/),
  {
    "kind": "Literal",
    "name": "canShowOnHoldForDifferentBuyer",
    "value": false
  },
  (v92/*: any*/),
  (v93/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v97 = [
  (v95/*: any*/),
  (v96/*: any*/)
],
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v97/*: any*/),
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVatIncluded",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": (v94/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v97/*: any*/),
      "storageKey": null
    },
    (v98/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "privateOfferConvertedAmountList",
      "plural": true,
      "selections": (v97/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateOfferPercentageOff",
      "storageKey": null
    },
    (v99/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerExpirationDate",
      "storageKey": null
    },
    (v100/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v102 = {
  "condition": "isMultiSku",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v101/*: any*/)
  ]
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPath",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnlimitedQuantity",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnpurchasable",
  "storageKey": null
},
v116 = {
  "alias": "priceType",
  "args": [
    {
      "kind": "Literal",
      "name": "buyerId",
      "value": ""
    },
    (v92/*: any*/),
    {
      "kind": "Literal",
      "name": "isTrade",
      "value": false
    }
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v99/*: any*/)
  ],
  "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
},
v117 = {
  "alias": null,
  "args": (v70/*: any*/),
  "concreteType": "Transaction",
  "kind": "LinkedField",
  "name": "lastActiveTransaction",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedCheckout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionType",
      "storageKey": null
    },
    (v67/*: any*/)
  ],
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "USD",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPricing",
  "kind": "LinkedField",
  "name": "pricing",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            (v119/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "GBP",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "EUR",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "CAD",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "AUD",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "CHF",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "MXN",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "NOK",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "SEK",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "DKK",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v122 = [
  (v98/*: any*/),
  (v100/*: any*/)
],
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "Hold",
  "kind": "LinkedField",
  "name": "activeHold",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTimeToExpire",
      "storageKey": null
    },
    (v67/*: any*/)
  ],
  "storageKey": null
},
v124 = [
  {
    "kind": "Literal",
    "name": "level",
    "value": 2
  }
],
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v126 = {
  "alias": "categoryL2",
  "args": (v124/*: any*/),
  "concreteType": "Category",
  "kind": "LinkedField",
  "name": "getCategoriesByLevel",
  "plural": true,
  "selections": [
    (v125/*: any*/),
    (v67/*: any*/)
  ],
  "storageKey": "getCategoriesByLevel(level:2)"
},
v127 = [
  (v69/*: any*/),
  {
    "kind": "Literal",
    "name": "isBuyerEstimateEnabled",
    "value": true
  },
  (v93/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v128 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      (v96/*: any*/),
      (v95/*: any*/)
    ],
    "storageKey": null
  }
],
v129 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": (v128/*: any*/),
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "minAmount",
  "plural": false,
  "selections": (v128/*: any*/),
  "storageKey": null
},
v131 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "maxAmount",
  "plural": false,
  "selections": (v128/*: any*/),
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": (v127/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    (v129/*: any*/),
    (v130/*: any*/),
    (v131/*: any*/)
  ],
  "storageKey": null
},
v133 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v132/*: any*/)
  ]
},
v134 = {
  "condition": "isPdpSimilarSoldItemsModuleVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v126/*: any*/),
    (v133/*: any*/)
  ]
},
v135 = {
  "alias": null,
  "args": [
    (v27/*: any*/),
    (v64/*: any*/),
    {
      "kind": "Variable",
      "name": "userZipCode",
      "variableName": "userZipCode"
    }
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v136 = {
  "alias": "makeOfferVpvParams",
  "args": [
    {
      "kind": "Literal",
      "name": "excludedPurchaseStatuses",
      "value": [
        "RET",
        "CUST"
      ]
    },
    (v64/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v139 = [
  {
    "kind": "Literal",
    "name": "shortTitles",
    "value": true
  }
],
v140 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabType",
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabTitle",
  "storageKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentHeader",
  "storageKey": null
},
v143 = [
  (v106/*: any*/),
  (v107/*: any*/)
],
v144 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentBodyText",
  "storageKey": null
},
v145 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "browseLink",
  "plural": false,
  "selections": (v143/*: any*/),
  "storageKey": null
},
v146 = {
  "kind": "InlineFragment",
  "selections": [
    (v67/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v147 = [
  (v43/*: any*/),
  (v67/*: any*/)
],
v148 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v149 = {
  "kind": "Literal",
  "name": "feedbackSellerPublicNoteHasText",
  "value": true
},
v150 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v151 = {
  "kind": "Literal",
  "name": "minimumReviewRating",
  "value": 4
},
v152 = [
  (v61/*: any*/)
],
v153 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerOrderQuantity",
  "storageKey": null
},
v154 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v155 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v154/*: any*/)
  ],
  "storageKey": null
},
v156 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCustomizable",
  "storageKey": null
},
v157 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v147/*: any*/),
  "storageKey": null
},
v158 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "customizable",
  "plural": true,
  "selections": [
    (v157/*: any*/),
    (v105/*: any*/)
  ],
  "storageKey": null
},
v159 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "ringResizable",
  "plural": true,
  "selections": [
    (v157/*: any*/)
  ],
  "storageKey": null
},
v160 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "leadTime",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        (v67/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seoDescription",
  "storageKey": null
},
v162 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v163 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delimiter",
  "storageKey": null
},
v164 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailDisplayName",
  "storageKey": null
},
v165 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPdpDetailValueInterface"
},
v166 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDetails",
  "storageKey": null
},
v167 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v56/*: any*/)
],
v168 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RingSizeDetail",
      "kind": "LinkedField",
      "name": "ringSizes",
      "plural": true,
      "selections": (v167/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PdpDetailRingSize",
  "abstractKey": null
},
v169 = {
  "alias": null,
  "args": null,
  "concreteType": "PdpDetail",
  "kind": "LinkedField",
  "name": "pdpDetailsDisplay",
  "plural": true,
  "selections": [
    (v162/*: any*/),
    (v163/*: any*/),
    (v164/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "detailValues",
      "plural": true,
      "selections": [
        (v61/*: any*/),
        (v165/*: any*/),
        (v162/*: any*/),
        (v52/*: any*/),
        (v104/*: any*/),
        (v166/*: any*/),
        (v91/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": [
                (v98/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "PdpDetailVersionsValue",
          "abstractKey": null
        },
        (v168/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v170 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAvailable",
  "storageKey": null
},
v171 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
],
v172 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        (v27/*: any*/)
      ],
      "concreteType": "InlineCtaCopy",
      "kind": "LinkedField",
      "name": "returnPolicySection",
      "plural": false,
      "selections": (v171/*: any*/),
      "storageKey": null
    }
  ]
},
v173 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "customizableDetailReturnCopy",
  "plural": false,
  "selections": (v171/*: any*/),
  "storageKey": null
},
v174 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "returnPolicySectionHeader",
  "plural": false,
  "selections": (v171/*: any*/),
  "storageKey": null
},
v175 = [
  (v69/*: any*/),
  (v93/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/)
],
v176 = {
  "alias": "recommendedPrice",
  "args": (v175/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    (v129/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "medianAmount",
      "plural": false,
      "selections": (v128/*: any*/),
      "storageKey": null
    },
    (v130/*: any*/),
    (v131/*: any*/)
  ],
  "storageKey": null
},
v177 = {
  "alias": "recommendedPrice",
  "args": (v175/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    (v114/*: any*/)
  ],
  "storageKey": null
},
v178 = [
  (v96/*: any*/)
],
v179 = {
  "alias": null,
  "args": (v127/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v178/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "minAmount",
      "plural": false,
      "selections": (v178/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "maxAmount",
      "plural": false,
      "selections": (v178/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v180 = {
  "alias": null,
  "args": (v80/*: any*/),
  "concreteType": "ReturnPolicy",
  "kind": "LinkedField",
  "name": "returnPolicy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeEuReturns",
          "value": true
        },
        (v27/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "returnDays",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v181 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v182 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "itemThumbnail",
          "args": (v181/*: any*/),
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"thumb\")"
        }
      ]
    }
  ]
},
v183 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v70/*: any*/),
      "kind": "ScalarField",
      "name": "hasActiveHoldForBuyer",
      "storageKey": null
    }
  ]
},
v184 = {
  "alias": "photoUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "master"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"master\")"
},
v185 = {
  "alias": null,
  "args": (v94/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v128/*: any*/),
  "storageKey": null
},
v186 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurementUnit",
  "storageKey": null
},
v187 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v188 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurementsList",
      "plural": true,
      "selections": [
        (v186/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        (v187/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diameter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v189 = {
  "alias": null,
  "args": null,
  "concreteType": "MCAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalyticsMetrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCMetricResponseTime",
          "kind": "LinkedField",
          "name": "responseTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryCopy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v190 = {
  "alias": null,
  "args": (v70/*: any*/),
  "kind": "ScalarField",
  "name": "hasRequestedHoldForBuyer",
  "storageKey": null
},
v191 = {
  "alias": null,
  "args": (v82/*: any*/),
  "concreteType": "ItemDisplayInfo",
  "kind": "LinkedField",
  "name": "displayInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHoldRequest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v192 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v193 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelrySeller",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v194 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "leadTimeDisplay",
  "storageKey": null
},
v195 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vimeoId",
  "storageKey": null
},
v196 = {
  "kind": "Literal",
  "name": "includePlayButton",
  "value": false
},
v197 = {
  "kind": "Literal",
  "name": "pad",
  "value": false
},
v198 = {
  "alias": null,
  "args": [
    (v196/*: any*/),
    (v197/*: any*/),
    {
      "kind": "Literal",
      "name": "size",
      "value": "w100h75"
    }
  ],
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
},
v199 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemReviewDocumentList",
  "kind": "LinkedField",
  "name": "reviews",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemReview",
      "kind": "LinkedField",
      "name": "videoReview",
      "plural": false,
      "selections": [
        (v118/*: any*/),
        (v67/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v200 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v201 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "IN"
        }
      ],
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurements",
      "plural": false,
      "selections": [
        (v187/*: any*/)
      ],
      "storageKey": "convertedMeasurements(unit:\"IN\")"
    },
    {
      "alias": "widthDimensions",
      "args": [
        (v200/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "width"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v167/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"width\"])"
    },
    {
      "alias": "heightDimensions",
      "args": [
        (v200/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v167/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"height\"])"
    }
  ],
  "storageKey": null
},
v202 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v203 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "sortedPhotos",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    (v109/*: any*/),
    (v202/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSkuXref",
      "kind": "LinkedField",
      "name": "imageSkuXrefs",
      "plural": true,
      "selections": [
        (v91/*: any*/),
        (v67/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    },
    (v67/*: any*/)
  ],
  "storageKey": null
},
v204 = {
  "alias": null,
  "args": null,
  "concreteType": "viewInRoomPhotos",
  "kind": "LinkedField",
  "name": "viewInRoomPhotos",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosCenterPosition",
      "kind": "LinkedField",
      "name": "centerPosition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "top",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "left",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosComparatorWidth",
      "kind": "LinkedField",
      "name": "comparatorWidth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pixel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inches",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v205 = [
  (v39/*: any*/),
  (v67/*: any*/)
],
v206 = [
  (v96/*: any*/),
  (v95/*: any*/),
  (v98/*: any*/)
],
v207 = {
  "alias": "suppressNewSellerSignals",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "suppressNewSellerSignals"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
},
v208 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  },
  (v63/*: any*/)
],
v209 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v210 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleItemSoldPrice",
  "storageKey": null
},
v211 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v212 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "countryCode",
      "variableName": "userCountryCode"
    }
  ],
  "kind": "ScalarField",
  "name": "isGdprApplicable",
  "storageKey": null
},
v213 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingOptInMessage",
  "storageKey": null
},
v214 = [
  (v211/*: any*/)
],
v215 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "similarSoldItemsResults",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        },
        (v63/*: any*/)
      ],
      "concreteType": "SimilarSoldItemsConnection",
      "kind": "LinkedField",
      "name": "similarSoldItems",
      "plural": false,
      "selections": (v214/*: any*/),
      "storageKey": null
    }
  ]
},
v216 = [
  {
    "alias": "videoUploadToolsFeatureFlag",
    "args": [
      {
        "kind": "Literal",
        "name": "feature",
        "value": "videoUploadTools"
      }
    ],
    "kind": "ScalarField",
    "name": "featureFlag",
    "storageKey": "featureFlag(feature:\"videoUploadTools\")"
  }
],
v217 = {
  "alias": null,
  "args": null,
  "concreteType": "gdprDisplayInfo",
  "kind": "LinkedField",
  "name": "gdprDisplayInfo",
  "plural": false,
  "selections": [
    (v212/*: any*/)
  ],
  "storageKey": null
},
v218 = [
  (v61/*: any*/),
  (v67/*: any*/)
],
v219 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "variant",
  "storageKey": null
},
v220 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v221 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v222 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v223 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    (v95/*: any*/)
  ],
  "storageKey": null
},
v224 = {
  "alias": "mcRedactionOpopAbTest",
  "args": [
    {
      "kind": "Literal",
      "name": "testName",
      "value": "MC_removeRedactionOPOP_Mar2026"
    }
  ],
  "concreteType": "AbTestConfigV2UserVariant",
  "kind": "LinkedField",
  "name": "abTestV2",
  "plural": false,
  "selections": [
    (v219/*: any*/)
  ],
  "storageKey": "abTestV2(testName:\"MC_removeRedactionOPOP_Mar2026\")"
},
v225 = [
  (v69/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
],
v226 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v227 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v228 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v215/*: any*/)
      ]
    }
  ]
},
v229 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v208/*: any*/),
      "concreteType": "SimilarSoldItemsConnectionConnection",
      "kind": "LinkedField",
      "name": "similarSoldItemsConnection",
      "plural": false,
      "selections": (v214/*: any*/),
      "storageKey": null
    }
  ]
},
v230 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v231 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canShowSellerName",
  "storageKey": null
},
v232 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "preferences",
    "plural": false,
    "selections": [
      (v186/*: any*/)
    ],
    "storageKey": null
  }
],
v233 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParentProgram",
      "kind": "LinkedField",
      "name": "currentProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "programInfo",
          "plural": false,
          "selections": (v68/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "ENHANCED_BUYER_PROTECTION"
            }
          ],
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "childPrograms",
          "plural": true,
          "selections": (v68/*: any*/),
          "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v234 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v235 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "PdpHeadBuilder_viewer",
            "selections": [
              (v23/*: any*/)
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespMarketplaceLayoutPrimary_viewer"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PersonalizedCollectionsContext_item"
                  },
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "PdpHeadBuilder_item",
                    "selections": [
                      (v25/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "pdpMetaItems",
                        "kind": "LinkedField",
                        "name": "pdpMeta",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "getLanguageAnnotations_pdpMetaItems",
                            "selections": [
                              (v37/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": [
                      {
                        "kind": "RootArgument",
                        "name": "forcedCurrency"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "priceBookName"
                      },
                      {
                        "kind": "RootArgument",
                        "name": "userCountryCode"
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "handlePdpStatuses_item",
                        "selections": [
                          (v32/*: any*/),
                          (v43/*: any*/),
                          (v30/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              (v53/*: any*/),
                              (v54/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v55/*: any*/),
                            "concreteType": "MetricDetailType",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": (v57/*: any*/),
                            "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                          },
                          (v58/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "findPdpItemReadError_itemRead",
                "selections": [
                  (v61/*: any*/),
                  (v62/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v14/*: any*/),
      (v15/*: any*/),
      (v21/*: any*/),
      (v20/*: any*/),
      (v22/*: any*/),
      (v13/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v17/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v19/*: any*/),
      (v0/*: any*/),
      (v16/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/),
      (v5/*: any*/),
      (v18/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          {
            "alias": null,
            "args": (v65/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v68/*: any*/),
            "storageKey": null
          },
          {
            "alias": "showAddToCartButton",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "multiItemCartAddToCartButton"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"multiItemCartAddToCartButton\")"
          },
          {
            "alias": null,
            "args": (v24/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v61/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isItemReadType"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "itemIsOnHold",
                    "args": (v70/*: any*/),
                    "kind": "ScalarField",
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v67/*: any*/),
                      (v54/*: any*/),
                      (v43/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v73/*: any*/),
                          (v77/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              (v78/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v79/*: any*/),
                          {
                            "alias": null,
                            "args": (v80/*: any*/),
                            "concreteType": "BuyerOrderReviewType",
                            "kind": "LinkedField",
                            "name": "buyerOrderReview",
                            "plural": false,
                            "selections": [
                              (v81/*: any*/),
                              (v32/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pdpUrl",
                                "storageKey": null
                              },
                              (v61/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v82/*: any*/),
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "kind": "LinkedField",
                        "name": "ctas",
                        "plural": false,
                        "selections": [
                          (v83/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showSale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showNet",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showUnavailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "kind": "LinkedField",
                            "name": "ctas",
                            "plural": false,
                            "selections": [
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              (v87/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "isPdpSiderailSellerReviewCombinedVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v88/*: any*/)
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "skus",
                    "plural": true,
                    "selections": [
                      (v43/*: any*/),
                      (v67/*: any*/),
                      (v90/*: any*/),
                      (v91/*: any*/),
                      {
                        "condition": "isPdpSiderailSellerReviewCombinedVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v102/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  (v103/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "kind": "LinkedField",
                    "name": "classification",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCategory",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "precedence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v52/*: any*/),
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          (v104/*: any*/),
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v67/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v105/*: any*/),
                      (v106/*: any*/),
                      (v107/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublishedPrivate",
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  (v108/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v109/*: any*/),
                      (v67/*: any*/),
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  (v90/*: any*/),
                  (v50/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMultiSku",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contemporaryTrackingString",
                    "storageKey": null
                  },
                  (v52/*: any*/),
                  (v110/*: any*/),
                  (v111/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplete",
                    "storageKey": null
                  },
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  (v28/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "pdpMetaItems",
                    "kind": "LinkedField",
                    "name": "pdpMeta",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/),
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v112/*: any*/),
                          (v113/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkuQuantityOption",
                            "kind": "LinkedField",
                            "name": "quantitySelectOptions",
                            "plural": true,
                            "selections": [
                              (v114/*: any*/),
                              (v56/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "setSize",
                            "storageKey": null
                          },
                          (v102/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v115/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SaveSearchDataType",
                        "kind": "LinkedField",
                        "name": "saveSearchData",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "page",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v116/*: any*/),
                      (v58/*: any*/),
                      (v117/*: any*/),
                      (v59/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v118/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v120/*: any*/),
                      (v51/*: any*/),
                      (v121/*: any*/),
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemAttributes",
                            "kind": "LinkedField",
                            "name": "attributes",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AttributeValue",
                                "kind": "LinkedField",
                                "name": "framingStatus",
                                "plural": true,
                                "selections": (v57/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "displayPriceDefault",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "DEFAULT"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v122/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"DEFAULT\")"
                              },
                              {
                                "alias": "displayPriceAU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "AU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v122/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"AU\")"
                              },
                              {
                                "alias": "displayPriceEU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "EU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v122/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"EU\")"
                              },
                              {
                                "alias": "displayPriceGB",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "GB"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v122/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"GB\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v123/*: any*/),
                          (v101/*: any*/),
                          (v134/*: any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v135/*: any*/),
                          (v136/*: any*/)
                        ]
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v82/*: any*/),
                                "concreteType": "SkuDisplayInfo",
                                "kind": "LinkedField",
                                "name": "displayInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CTADisplay",
                                    "kind": "LinkedField",
                                    "name": "ctas",
                                    "plural": false,
                                    "selections": [
                                      (v84/*: any*/),
                                      (v85/*: any*/),
                                      (v86/*: any*/),
                                      (v87/*: any*/),
                                      (v83/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isPdpSiderailSellerReviewCombinedVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SkuRingSizeDisplay",
                                "kind": "LinkedField",
                                "name": "ringSizeDisplay",
                                "plural": false,
                                "selections": [
                                  (v137/*: any*/),
                                  (v138/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "storyTelling",
                        "args": (v139/*: any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v140/*: any*/),
                              (v141/*: any*/),
                              (v142/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "kind": "LinkedField",
                                "name": "contentCreatorAttribution",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "creatorName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LinkData",
                                    "kind": "LinkedField",
                                    "name": "creatorBrowseUrl",
                                    "plural": false,
                                    "selections": (v143/*: any*/),
                                    "storageKey": null
                                  },
                                  (v61/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v144/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mainImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mainVideo",
                                "storageKey": null
                              },
                              (v145/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "smallImage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v73/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorefrontProfile",
                            "kind": "LinkedField",
                            "name": "liveStorefrontProfile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "aboutUsUnbranded",
                                "storageKey": null
                              },
                              (v67/*: any*/),
                              {
                                "alias": "headshots",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "photoType",
                                    "value": "DEALER_STOREFRONT_HEADSHOT"
                                  }
                                ],
                                "concreteType": "Photo",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v118/*: any*/),
                                  (v106/*: any*/),
                                  (v67/*: any*/)
                                ],
                                "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaAlbum",
                                "kind": "LinkedField",
                                "name": "galleryAlbum",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MediaElement",
                                    "kind": "LinkedField",
                                    "name": "mediaList",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "element",
                                        "plural": false,
                                        "selections": [
                                          (v61/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v106/*: any*/)
                                            ],
                                            "type": "Photo",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "Video",
                                            "abstractKey": null
                                          },
                                          (v146/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "establishmentYear",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              (v78/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v147/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v71/*: any*/),
                          (v72/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "shippingAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "displayFullCityStateCountry",
                                "args": (v148/*: any*/),
                                "kind": "ScalarField",
                                "name": "displayCityStateCountry",
                                "storageKey": "displayCityStateCountry(fullCountryName:true)"
                              },
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v77/*: any*/),
                          {
                            "alias": "dealerDetailsHeaderFeedback",
                            "args": [
                              (v149/*: any*/),
                              (v150/*: any*/),
                              (v151/*: any*/)
                            ],
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v152/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
                          },
                          (v79/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "agreementStart",
                            "storageKey": null
                          },
                          (v153/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalytics",
                            "kind": "LinkedField",
                            "name": "analytics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCAnalyticsMetrics",
                                "kind": "LinkedField",
                                "name": "metrics",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MCMetricResponseTime",
                                    "kind": "LinkedField",
                                    "name": "responseTime",
                                    "plural": false,
                                    "selections": (v57/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeAssociation",
                            "kind": "LinkedField",
                            "name": "tradeAssociations",
                            "plural": true,
                            "selections": [
                              (v43/*: any*/),
                              (v104/*: any*/),
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "dealerDetailsOrderFeedbackPdp",
                                "args": [
                                  (v149/*: any*/),
                                  (v150/*: any*/),
                                  (v151/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "sortBy",
                                    "value": "sellerExperienceDesc"
                                  }
                                ],
                                "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                                "kind": "LinkedField",
                                "name": "orderFeedbackPdp",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderFeedbackPdp",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "completedDate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "kind": "LinkedField",
                                            "name": "transaction",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "buyer",
                                                "plural": false,
                                                "selections": [
                                                  (v155/*: any*/),
                                                  (v67/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Shipment",
                                                "kind": "LinkedField",
                                                "name": "shipment",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "kind": "LinkedField",
                                                    "name": "shippingAddress",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "displayState",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "displayCountry",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "country",
                                                        "storageKey": null
                                                      },
                                                      (v67/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v67/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v67/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "overallExperience",
                                            "plural": false,
                                            "selections": [
                                              (v61/*: any*/),
                                              (v81/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "publicNote",
                                            "plural": false,
                                            "selections": [
                                              (v61/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "freetext",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v67/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v156/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v158/*: any*/),
                          (v159/*: any*/),
                          (v160/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v47/*: any*/),
                      (v161/*: any*/),
                      (v169/*: any*/),
                      (v170/*: any*/),
                      (v59/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v80/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accept",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v172/*: any*/),
                              (v173/*: any*/),
                              (v174/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "itemAddress",
                            "args": (v148/*: any*/),
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v115/*: any*/),
                      (v116/*: any*/),
                      (v176/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v177/*: any*/),
                          (v179/*: any*/),
                          (v180/*: any*/)
                        ]
                      },
                      (v182/*: any*/),
                      (v183/*: any*/),
                      {
                        "condition": "isPdpSimilarSoldItemsModuleVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v126/*: any*/),
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "categoryL2",
                                "args": (v124/*: any*/),
                                "concreteType": "Category",
                                "kind": "LinkedField",
                                "name": "getCategoriesByLevel",
                                "plural": true,
                                "selections": [
                                  (v39/*: any*/),
                                  (v67/*: any*/),
                                  (v125/*: any*/)
                                ],
                                "storageKey": "getCategoriesByLevel(level:2)"
                              },
                              (v184/*: any*/),
                              (v185/*: any*/),
                              (v188/*: any*/),
                              (v132/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "fetchPdp",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Phone",
                                "kind": "LinkedField",
                                "name": "trackedPhone",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "phoneNumber",
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v189/*: any*/),
                              (v61/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "dealerDetailsDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v88/*: any*/),
                            "storageKey": null
                          },
                          {
                            "condition": "fetchUser",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v190/*: any*/),
                              (v191/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v176/*: any*/),
                      (v179/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v160/*: any*/),
                          (v158/*: any*/),
                          (v159/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v80/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v174/*: any*/),
                              (v172/*: any*/),
                              (v173/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v192/*: any*/),
                      (v161/*: any*/),
                      (v156/*: any*/),
                      (v169/*: any*/),
                      (v170/*: any*/),
                      (v59/*: any*/),
                      (v193/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelry",
                        "storageKey": null
                      },
                      (v116/*: any*/),
                      (v194/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v180/*: any*/),
                          (v190/*: any*/),
                          (v191/*: any*/)
                        ]
                      },
                      (v183/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "kind": "LinkedField",
                        "name": "videoVimeo",
                        "plural": false,
                        "selections": [
                          (v118/*: any*/),
                          (v195/*: any*/),
                          (v61/*: any*/),
                          (v198/*: any*/),
                          {
                            "alias": null,
                            "args": (v89/*: any*/),
                            "concreteType": "VideoVimeoFile",
                            "kind": "LinkedField",
                            "name": "fileByVideoSize",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "link",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "fileByVideoSize(size:\"small\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v199/*: any*/),
                      (v33/*: any*/),
                      (v201/*: any*/),
                      (v203/*: any*/),
                      (v204/*: any*/),
                      (v59/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "kind": "LinkedField",
                        "name": "videoVimeo",
                        "plural": false,
                        "selections": [
                          (v118/*: any*/),
                          (v195/*: any*/),
                          (v61/*: any*/),
                          (v198/*: any*/),
                          {
                            "alias": "previewThumbnail",
                            "args": [
                              (v196/*: any*/),
                              (v197/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w960h540"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w960h540\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v199/*: any*/),
                      (v33/*: any*/),
                      (v201/*: any*/),
                      (v203/*: any*/),
                      (v204/*: any*/),
                      (v59/*: any*/)
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v121/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "kind": "LinkedField",
                        "name": "variableAttributes",
                        "plural": true,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "kind": "LinkedField",
                            "name": "variableAttributeData",
                            "plural": false,
                            "selections": [
                              (v104/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "kind": "LinkedField",
                                "name": "primaryAttribute",
                                "plural": false,
                                "selections": (v205/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "kind": "LinkedField",
                                "name": "swatchSort",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortOrder",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "kind": "LinkedField",
                                    "name": "swatch",
                                    "plural": false,
                                    "selections": [
                                      (v43/*: any*/),
                                      (v104/*: any*/),
                                      (v33/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "ringSize",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SwatchAttributeByNameProperties",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                              (v138/*: any*/),
                                              (v137/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "material",
                                        "plural": false,
                                        "selections": (v40/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentName",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "buyerSideSkus",
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": (v181/*: any*/),
                            "kind": "ScalarField",
                            "name": "firstPhotoWebPath",
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidePrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": (v206/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "netPrice",
                                "plural": false,
                                "selections": (v206/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "salePrice",
                                "plural": false,
                                "selections": (v206/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v112/*: any*/),
                          (v113/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "leadTime",
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "kind": "LinkedField",
                            "name": "variableAttributeSelections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "kind": "LinkedField",
                                "name": "variableAttribute",
                                "plural": false,
                                "selections": (v147/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "kind": "LinkedField",
                                "name": "swatch",
                                "plural": false,
                                "selections": (v147/*: any*/),
                                "storageKey": null
                              },
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPdpSiderailSellerReviewCombinedVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v170/*: any*/),
                      (v161/*: any*/),
                      (v59/*: any*/),
                      (v193/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCondition",
                        "kind": "LinkedField",
                        "name": "condition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "state",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PdpDetail",
                        "kind": "LinkedField",
                        "name": "pdpDetailsDisplay",
                        "plural": true,
                        "selections": [
                          (v162/*: any*/),
                          (v163/*: any*/),
                          (v164/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "detailValues",
                            "plural": true,
                            "selections": [
                              (v61/*: any*/),
                              (v91/*: any*/),
                              (v52/*: any*/),
                              (v162/*: any*/),
                              (v104/*: any*/),
                              (v166/*: any*/),
                              (v165/*: any*/),
                              (v168/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v139/*: any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v140/*: any*/),
                              (v141/*: any*/),
                              (v142/*: any*/),
                              (v144/*: any*/),
                              (v145/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "kind": "LinkedField",
                                "name": "contentCreatorAttribution",
                                "plural": false,
                                "selections": (v152/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      (v156/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v158/*: any*/),
                          (v159/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v116/*: any*/),
                      (v194/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      (v123/*: any*/),
                      (v101/*: any*/),
                      (v58/*: any*/),
                      (v117/*: any*/),
                      (v120/*: any*/),
                      (v183/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v177/*: any*/),
                          (v135/*: any*/),
                          (v136/*: any*/)
                        ]
                      },
                      (v182/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPdpSimilarSoldItemsModuleVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v126/*: any*/),
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v134/*: any*/)
                        ]
                      },
                      (v133/*: any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v47/*: any*/),
                      (v48/*: any*/),
                      (v49/*: any*/),
                      (v51/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v53/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v55/*: any*/),
                        "concreteType": "MetricDetailType",
                        "kind": "LinkedField",
                        "name": "metrics",
                        "plural": true,
                        "selections": [
                          (v56/*: any*/),
                          (v67/*: any*/)
                        ],
                        "storageKey": "metrics(metricTypes:[\"ITEM_LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")"
                      },
                      (v58/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/)
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v146/*: any*/),
              (v62/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "similarLandingItems",
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "similarItemsCount"
              },
              (v93/*: any*/),
              (v63/*: any*/),
              {
                "kind": "Literal",
                "name": "useML",
                "value": true
              }
            ],
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v43/*: any*/),
                      (v111/*: any*/),
                      (v110/*: any*/),
                      (v52/*: any*/),
                      (v32/*: any*/),
                      (v192/*: any*/),
                      (v29/*: any*/),
                      (v103/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCreator",
                        "kind": "LinkedField",
                        "name": "creators",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Creator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v205/*: any*/),
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 1
                          }
                        ],
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v202/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              (v38/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": "photos(limit:1)"
                      },
                      (v67/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v67/*: any*/),
          {
            "condition": "isPdpSiderailSellerReviewCombinedVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v207/*: any*/),
              {
                "condition": "isPdpSimilarSoldItemsModuleVariant",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v208/*: any*/),
                        "concreteType": "SimilarSoldItemsConnectionConnection",
                        "kind": "LinkedField",
                        "name": "similarSoldItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimilarSoldItemsConnectionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SimilarSoldItemsNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v209/*: any*/),
                                  (v210/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v52/*: any*/),
                                      (v110/*: any*/),
                                      (v192/*: any*/),
                                      (v67/*: any*/),
                                      (v43/*: any*/),
                                      (v32/*: any*/),
                                      (v108/*: any*/),
                                      (v184/*: any*/),
                                      (v30/*: any*/),
                                      (v185/*: any*/),
                                      (v188/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PdpDetail",
                                        "kind": "LinkedField",
                                        "name": "pdpDetailsDisplay",
                                        "plural": true,
                                        "selections": [
                                          (v162/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "detailValues",
                                            "plural": true,
                                            "selections": [
                                              (v61/*: any*/),
                                              (v104/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "soldDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v211/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "gdprDisplayInfo",
                    "kind": "LinkedField",
                    "name": "gdprDisplayInfo",
                    "plural": false,
                    "selections": [
                      (v212/*: any*/),
                      (v213/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "detectFeedbackLanguage",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "detectFeedbackLanguage"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
                  }
                ]
              },
              (v215/*: any*/)
            ]
          },
          {
            "condition": "isPDPLargerItemsVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v216/*: any*/)
          },
          {
            "condition": "isPDPLargerItemsVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v216/*: any*/)
          },
          {
            "condition": "fetchPdp",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "isPdpStfEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "enablePdpStf"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"enablePdpStf\")"
              },
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "fetchPdp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v217/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "gdprDisplayInfo",
                            "kind": "LinkedField",
                            "name": "gdprDisplayInfo",
                            "plural": false,
                            "selections": [
                              (v213/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v24/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v135/*: any*/),
                      {
                        "alias": null,
                        "args": (v80/*: any*/),
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": (v68/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerTiers",
                            "kind": "LinkedField",
                            "name": "sellerTiers",
                            "plural": false,
                            "selections": [
                              (v74/*: any*/),
                              (v75/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dealerSince",
                            "storageKey": null
                          },
                          (v153/*: any*/),
                          (v73/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotos",
                        "kind": "LinkedField",
                        "name": "viewInRoomPhotos",
                        "plural": true,
                        "selections": (v152/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": (v218/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v179/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2UserVariant",
                            "kind": "LinkedField",
                            "name": "seoAbTestV2List",
                            "plural": true,
                            "selections": [
                              (v219/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AbTestConfigV2",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "testName",
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v63/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "personalizationId"
                  }
                ],
                "concreteType": "PersonalizedItems",
                "kind": "LinkedField",
                "name": "personalizedItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPersonalizedItem",
                    "storageKey": null
                  },
                  (v67/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v65/*: any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalConversations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUrgencyInfo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v63/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v217/*: any*/),
              (v207/*: any*/),
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v80/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v218/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isInteractivePdpChat",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v24/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "itemRead",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerTiers",
                                "kind": "LinkedField",
                                "name": "sellerTiers",
                                "plural": false,
                                "selections": [
                                  (v76/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v189/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "shippingAddress",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayCityStateCountry",
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresenceResults",
                                "kind": "LinkedField",
                                "name": "presence",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "recentOnlineDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showOnlineStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v156/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnavailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      (v119/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "regionName",
                                        "storageKey": null
                                      },
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "buyerChatDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v88/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Item",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "presenceFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "presence"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"presence\")"
                  },
                  {
                    "alias": "readReceiptsFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "readReceipts"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"readReceipts\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v69/*: any*/),
                          (v63/*: any*/)
                        ],
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "buyerItemConversation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasMessageFromSeller",
                            "storageKey": null
                          },
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "originalBuyer",
                            "plural": false,
                            "selections": (v147/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": (v147/*: any*/),
                                "storageKey": null
                              },
                              (v67/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "kind": "LinkedField",
                                "name": "orderFeedback",
                                "plural": false,
                                "selections": [
                                  (v118/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "token",
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "sellerMember",
                            "plural": false,
                            "selections": [
                              (v43/*: any*/),
                              (v67/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastConversationReadDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userType",
                                    "value": "BUYER"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "translatedTextBody",
                                "storageKey": "translatedTextBody(userType:\"BUYER\")"
                              },
                              (v67/*: any*/),
                              (v43/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textBody",
                                "storageKey": null
                              },
                              (v220/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fromUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shipmentTrackingNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v205/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": (v218/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedNetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadePrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeNetPriceOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionAutomatedPrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionSpecialShippingRequests",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldPlaced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCallInitiated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomizationOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomization",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBundledOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferHoldSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionInternalAdminJoined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMarkedShipped",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclinedApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionDealerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBuyerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v43/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isApoFromCart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expirationDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isExpired",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSubmitted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevisedByDealer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCountered",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "amountPerItem",
                                    "plural": false,
                                    "selections": (v128/*: any*/),
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "kind": "LinkedField",
                                "name": "transaction",
                                "plural": false,
                                "selections": [
                                  (v221/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "kind": "LinkedField",
                                    "name": "mostRecentOffer",
                                    "plural": false,
                                    "selections": (v147/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "offerDiscountPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": (v147/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v80/*: any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              (v154/*: any*/),
                              (v222/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v223/*: any*/),
                          (v224/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Summary",
                            "kind": "LinkedField",
                            "name": "conversationSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unread",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v225/*: any*/),
                        "concreteType": "ConversationsSolrConnection",
                        "kind": "LinkedField",
                        "name": "conversationsSolr",
                        "plural": false,
                        "selections": [
                          (v211/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationsSolrEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Conversation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v43/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessage",
                                    "storageKey": null
                                  },
                                  (v220/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inboxImage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numberOfMessages",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v32/*: any*/),
                                      (v43/*: any*/),
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemSkuType",
                                    "kind": "LinkedField",
                                    "name": "sku",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "skuPhotoWebPath",
                                        "args": (v89/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessageReceivedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "hasReplied",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLatestMessageSender",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMember",
                                    "kind": "LinkedField",
                                    "name": "originalBuyer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasUnreadTag",
                                        "storageKey": null
                                      },
                                      (v67/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v67/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v226/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v227/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v225/*: any*/),
                        "filters": [
                          "page",
                          "buyerId"
                        ],
                        "handle": "connection",
                        "key": "BuyerChatVariant_conversations",
                        "kind": "LinkedHandle",
                        "name": "conversationsSolr"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isPdpSiderailSellerReviewCombinedVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v228/*: any*/)
            ]
          },
          (v228/*: any*/),
          {
            "condition": "isPdpSimilarSoldItemsModuleVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "afterDisplayOrBtSsr",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "isPdpSimilarSoldItemsModuleVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v229/*: any*/)
                    ]
                  },
                  {
                    "alias": null,
                    "args": (v208/*: any*/),
                    "concreteType": "SimilarSoldItemsConnectionConnection",
                    "kind": "LinkedField",
                    "name": "similarSoldItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimilarSoldItemsNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v209/*: any*/),
                              (v210/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v52/*: any*/),
                                  (v110/*: any*/),
                                  (v192/*: any*/),
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              (v229/*: any*/)
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v80/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v222/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v61/*: any*/),
                  (v43/*: any*/),
                  (v67/*: any*/),
                  {
                    "condition": "isPdpSiderailSellerReviewCombinedVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v155/*: any*/),
                      (v230/*: any*/),
                      (v223/*: any*/),
                      (v224/*: any*/),
                      (v231/*: any*/),
                      {
                        "condition": "isPdpSimilarSoldItemsModuleVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": (v232/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "kind": "LinkedField",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              (v233/*: any*/),
                              (v67/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v234/*: any*/),
                          (v66/*: any*/),
                          (v67/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v80/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v66/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v67/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v234/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v80/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": (v232/*: any*/)
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v232/*: any*/)
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v230/*: any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v230/*: any*/),
                      (v231/*: any*/),
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "kind": "LinkedField",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              (v233/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v230/*: any*/),
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v235/*: any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v43/*: any*/),
                                      (v104/*: any*/),
                                      (v67/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v61/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v226/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v227/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v235/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isMultiSku",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "kind": "LinkedField",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v91/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivateOffer",
                            "storageKey": null
                          },
                          (v221/*: any*/),
                          (v67/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/556.0.0-2026-04-21T14:51:08.285Z/pdpRespMarketplacePrimaryRootQuery",
    "metadata": {},
    "name": "pdpRespMarketplacePrimaryRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "94a07b074d937b3bd83799cf42dcfcfa";

export default node;
